import { jsxs as e, jsx as i } from "react/jsx-runtime";
import t from "./index.es5823.js";
import { Divider as l } from "./index.es24.js";
import { UpsellLabel as o } from "./index.es156.js";
const c = ({ children: r, isUpsell: a }) => /* @__PURE__ */ e("div", { className: t.container, "data-pl-identifier": "label-containers", children: [
  r,
  a && /* @__PURE__ */ e("div", { className: t.upsellContainer, children: [
    !!r && /* @__PURE__ */ i(l, { isVertical: !0, margin: "2px 0 0 0" }),
    /* @__PURE__ */ i(o, {})
  ] })
] });
export {
  c as LabelContainer
};
//# sourceMappingURL=index.es5586.js.map
